import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productHintsCardHeader: {
    id: 'productHintsCard.header',
    defaultMessage: 'Hinweise',
  },
});
